export default function ValueSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left - Text */}
          <div className="lg:w-[55%]">
            <span className="inline-block px-3 py-1 text-xs font-medium text-foreground-500 bg-background-100 rounded-lg whitespace-nowrap">
              Sobre o Hoobuy Spreadsheet
            </span>
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mt-5 leading-tight">
              Planilha Inteligente
              <br />
              Para Compras
              <br />
              Na China
            </h2>
            <p className="mt-6 text-sm md:text-base text-foreground-500 leading-relaxed max-w-lg">
              Organize seus produtos e encontre os melhores fornecedores verificados com segurança e rapidez em um só lugar. O hoobuy spreadsheet foi criado para facilitar a sua experiência de compras internacionais.
            </p>
          </div>

          {/* Right - Green Card */}
          <div className="lg:w-[45%]">
            <div className="bg-secondary-500 rounded-2xl p-8 md:p-10 relative overflow-hidden">
              <div className="flex items-start justify-between mb-6">
                <span className="text-xs text-white/60 font-medium">
                  Por que escolher?
                </span>
                <span className="flex gap-1">
                  <span className="w-1.5 h-1.5 rounded-full bg-white/40"></span>
                  <span className="w-1.5 h-1.5 rounded-full bg-white/40"></span>
                  <span className="w-1.5 h-1.5 rounded-full bg-white/40"></span>
                </span>
              </div>
              <blockquote className="text-lg md:text-xl lg:text-2xl font-heading font-semibold text-white leading-relaxed">
                &ldquo;O Hoobuy Spreadsheet é a forma mais rápida e segura de encontrar produtos atualizados na China.&rdquo;
              </blockquote>
              <div className="flex items-center gap-3 mt-8">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                  <span className="w-5 h-5 flex items-center justify-center text-white">
                    <i className="ri-shield-check-line text-lg"></i>
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">
                    Verificado
                  </p>
                  <p className="text-xs text-white/60">
                    Links Revisados Manualmente
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}